"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _flex = _interopRequireDefault(require("../../styles-common/flex"));

var _flexController = _interopRequireDefault(require("../../styles-common/flex-controller"));

var _slider = _interopRequireDefault(require("../slider"));

var _formLabel = _interopRequireDefault(require("../../styles-common/form-label"));

var _inputGroup = _interopRequireDefault(require("../../styles-common/input-group"));

var _input = _interopRequireDefault(require("../../styles-common/input"));

var _isFloat = _interopRequireDefault(require("@widget-editor/shared/lib/helpers/isFloat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var RangeWrapper = _styledComponents["default"].div.withConfig({
  displayName: "component__RangeWrapper",
  componentId: "sc-1a2sw2e-0"
})(["padding:10px 10px;box-sizing:border-box;.rc-slider-handle{margin-top:-7px;}"]);

var QueryLimit = function QueryLimit(_ref) {
  var label = _ref.label,
      _ref$dateType = _ref.dateType,
      dateType = _ref$dateType === void 0 ? false : _ref$dateType,
      _ref$isFilter = _ref.isFilter,
      isFilter = _ref$isFilter === void 0 ? false : _ref$isFilter,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? null : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? null : _ref$max,
      value = _ref.value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange;

  var _ref2 = (0, _react.useState)({
    value: value,
    key: null
  }),
      _ref3 = _slicedToArray(_ref2, 2),
      localValue = _ref3[0],
      setLocalValue = _ref3[1];

  var changeValue = function changeValue(data) {
    if (data.value !== 0) {
      setLocalValue(data);
      debounceOnChange(data);
    }
  };

  var debounceOnChange = (0, _debounce["default"])(function (q) {
    onChange(q.value, q.key);
  }, 1000);
  var isDouble = Array.isArray(localValue);
  var isFloatingPoint = (0, _isFloat["default"])(min) || (0, _isFloat["default"])(max);
  var minValue = min;
  var maxValue = max;

  if (isDouble) {
    minValue = localValue[0];
    maxValue = localValue[1];
  } else {
    var _localValue$value;

    maxValue = (_localValue$value = localValue.value) !== null && _localValue$value !== void 0 ? _localValue$value : max;
  }

  var minMaxProps = _objectSpread({}, min !== null && {
    min: min
  }, {}, max !== null && {
    max: max
  });

  var sliderValue = (0, _react.useMemo)(function () {
    return isDouble ? [minValue, maxValue] : maxValue;
  }, [isDouble, minValue, maxValue]);
  var onChangeDebounced = (0, _react.useCallback)((0, _debounce["default"])(onChange, 1000), [onChange]);
  var onChangeValue = (0, _react.useCallback)(function (value) {
    setLocalValue(value);
    onChangeDebounced(value);
  }, [setLocalValue, onChangeDebounced]);
  return _react["default"].createElement(_inputGroup["default"], null, label && _react["default"].createElement(_formLabel["default"], {
    htmlFor: "options-limit-max"
  }, label), !isFilter && _react["default"].createElement(_flex["default"], {
    row: true
  }, _react["default"].createElement(_flexController["default"], {
    contain: 20
  }, _react["default"].createElement(_input["default"], _extends({}, minMaxProps, {
    step: isFloatingPoint ? 0.1 : 1,
    value: localValue.value,
    type: dateType ? "date" : "number",
    name: "options-limit-max",
    onChange: function onChange(e) {
      return changeValue({
        value: e.target.value,
        key: "maxValue"
      });
    }
  }))), _react["default"].createElement(_flexController["default"], {
    contain: 80
  }, _react["default"].createElement(_slider["default"], _extends({}, minMaxProps, {
    step: isFloatingPoint ? 0.1 : 1,
    value: isDouble ? [minValue, maxValue] : maxValue,
    defaultValue: isDouble ? min : [min, max],
    onChange: function onChange(value) {
      return changeValue({
        value: value,
        key: null
      });
    }
  })))), isFilter && _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_flex["default"], {
    row: true
  }, _react["default"].createElement(_flexController["default"], {
    contain: 100
  }, _react["default"].createElement(RangeWrapper, null, _react["default"].createElement(_slider["default"], _extends({}, minMaxProps, {
    step: isFloatingPoint ? 0.1 : 1,
    value: isDouble ? [minValue, maxValue] : maxValue,
    defaultValue: isDouble ? min : [min, max],
    onChange: function onChange(value) {
      return changeValue({
        value: value,
        key: null
      });
    }
  }))))), _react["default"].createElement(_flex["default"], {
    row: true
  }, _react["default"].createElement(_flexController["default"], {
    contain: 50,
    constrainElement: 40
  }, _react["default"].createElement(_input["default"], _extends({}, minMaxProps, {
    value: minValue,
    type: dateType ? "date" : "number",
    name: "options-limit-min",
    onChange: function onChange(e) {
      return changeValue({
        value: e.target.value,
        key: "minValue"
      });
    }
  }))), _react["default"].createElement(_flexController["default"], {
    contain: 50,
    constrainElement: 40,
    alignment: "right"
  }, _react["default"].createElement(_input["default"], _extends({}, minMaxProps, {
    step: isFloatingPoint ? 0.1 : 1,
    value: maxValue,
    type: dateType ? "date" : "number",
    name: "options-limit-max",
    onChange: function onChange(e) {
      return changeValue({
        value: e.target.value,
        key: "maxValue"
      });
    }
  }))))));
};

var _default = QueryLimit;
exports["default"] = _default;